// extracted by mini-css-extract-plugin
module.exports = {"main-container":"ceoEventImage_main-container__3EKOL"};